import Vue from 'vue'

import ScrollLock from '@/directives/v-scroll-lock'
import Resize from '@/directives/v-resize'

Vue.directive('scroll-lock', ScrollLock)
Vue.directive('resize', Resize)
